module.exports = __webpack_public_path__ + "ef2cfc63c2a7a75425b2e3e0e7450bd4.svg";